import styled from 'styled-components'

const ImgResponsive = styled.img`
  display: block;
  max-width: 100%;
  height: auto;
`

export default ImgResponsive
